// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HZTX","rootMobile":"styles_rootMobile__kW2H7"};